module.exports = __webpack_public_path__ + "static/media/Novecentowide-Bold.d41d8cd9.otf";